import produce from 'immer';
import { DashboardAction } from '../actions/Dashboard';
import { EnvironmentsAction } from '../actions/Environments';
import * as Constants from '../constants/action-constants';
import initialState from '../InitialState';
import { Dashboard } from '../types/Dashboard';
const dashboard = (
  state: Dashboard = initialState.lcopsDashboard,
  action: DashboardAction | EnvironmentsAction
): Dashboard => {
  return produce<Dashboard, Dashboard>(state, draft => {
    switch (action.type) {
      case Constants.REQUEST_ACTIONS:
        draft.actions.fetching = true;
        break;
      case Constants.REQUEST_ACTIONS_SUCCESS:
        draft.actions.fetching = false;
        draft.actions.items = action.payload.actions;
        break;
      case Constants.REQUEST_MAP_DATA:
      case Constants.POLL_ENVIRONMENTS:
        draft.mapData.fetching = true;
        draft.mapData.failed = false;
        break;
      case Constants.REQUEST_MAP_DATA_SUCCESS:
        draft.mapData.fetching = false;
        draft.mapData.markers = action.payload.markers;
        break;
      case Constants.REQUEST_MAP_DATA_FAILED:
      case Constants.POLL_ENVIRONMENTS_FAILED:
        draft.mapData.fetching = false;
        draft.mapData.failed = true;
        break;
      // no default
    }
  });
};

export default dashboard;
